import {
  DeliveryPointsItem,
  DeliveryStatus,
  GroupAgreementSections,
  SectionStatusStatuses,
} from '../entities/installation-reporting-mdu.entities';

export interface DeliveryStatusTag {
  label: string;
  variant: 'caution' | 'success';
}

const DELIVERY_STATUS_TAGS: Record<string, DeliveryStatusTag> = {
  [DeliveryStatus.BOM]: {
    label: 'installationReportV2.orderOverviewTab.bomTag',
    variant: 'caution',
  },
  [SectionStatusStatuses.DONE]: {
    label: 'installationReportV2.orderOverviewTab.doneTag',
    variant: 'success',
  },
};

const DELIVERY_POINT_SECTIONS = [
  GroupAgreementSections.PRE_INSTALLATION,
  GroupAgreementSections.SPLICING_MEASURING,
  GroupAgreementSections.COMMISSION,
];

const COMPLETED_SECTION_STATUSES: string[] = [
  SectionStatusStatuses.DONE,
  SectionStatusStatuses.NOT_APPLICABLE,
];

export const getDeliveryStatusTag = (
  status?: string | null,
): DeliveryStatusTag | null =>
  status ? (DELIVERY_STATUS_TAGS[status] ?? null) : null;

export const getDeliveryPointDeliveryStatus = (
  item: Pick<DeliveryPointsItem, 'deliveryStatus'> & {
    sectionStatuses?: DeliveryPointsItem['sectionStatuses'];
  },
): string => {
  if (item.deliveryStatus === DeliveryStatus.BOM) {
    return DeliveryStatus.BOM;
  }
  const allSectionsCompleted = DELIVERY_POINT_SECTIONS.every((section) =>
    COMPLETED_SECTION_STATUSES.includes(
      item.sectionStatuses?.[section]?.status ?? '',
    ),
  );
  return allSectionsCompleted ? SectionStatusStatuses.DONE : '';
};
